export default "__VITE_ASSET__BkU_sk_H__"